import { getCookie, setCookie as setCookieValue } from '#pplx/frontend/cookies/provider.js';
import { useCallback, useEffect, useState } from 'react';
/**
 * Gets a cookie value and refetches it when the cookie changes.
 * @param name - The name the cookie is stored under.
 * @returns The cookie value and a function to refetch the cookie.
 */
export function useGetCookie(name) {
    const [value, setValue] = useState(getCookie(name));
    const refetch = useCallback(() => {
        // Do nothing if we're relying on cookieStore event
        if (window.cookieStore) {
            return;
        }
        setValue(getCookie(name));
    }, [name]);
    useEffect(() => {
        const cookieStore = window.cookieStore;
        if (!cookieStore) {
            return;
        }
        const handler = (event) => {
            const deletedCookie = event.deleted.find((cookie) => cookie.name === name);
            const changedCookie = event.changed.find((cookie) => cookie.name === name);
            if (deletedCookie) {
                setValue(undefined);
            }
            else if (changedCookie) {
                setValue(changedCookie.value);
            }
        };
        cookieStore.addEventListener('change', handler);
        return () => {
            cookieStore.removeEventListener('change', handler);
        };
    }, [name]);
    const setCookie = useCallback((value, options) => {
        setCookieValue(name, value, options);
        refetch();
    }, [name, refetch]);
    return { value, refetch, setCookie };
}
//# sourceMappingURL=useGetCookie.js.map